import React from 'react';
import { Link } from 'react-router-dom';
import HeroSectionComponent from '../HeroSection';
import Services from '../Services';
import Testimonial from '../Testimonial';
import Slidingimages from '../Slidingimages';
import About from '../About';
import Contact from '../Contact';
import Career from '../Career';
import MSMEComponent from '../Msme';
import ProductPage from '../product/ProductPage';
import OurTeam from '../OurTeam';
import Brochure from '../Brochure';

function DynamicHero({ content }) {
  const stats = Array.isArray(content?.stats) ? content.stats : [];
  return (
    <section className="home-banner">
      <div className="home-overlay" />
      <div className="home-content">
        {content?.kicker ? <p className="home-kicker">{content.kicker}</p> : null}
        <h1>{content?.title || 'Hero title'}</h1>
        {content?.subtitle ? <p className="home-subtitle">{content.subtitle}</p> : null}
        <div className="home-cta">
          {content?.ctaPrimary?.url ? (
            <Link to={content.ctaPrimary.url} className="home-btn primary">
              {content?.ctaPrimary?.label || 'Learn More'}
            </Link>
          ) : null}
          {content?.ctaSecondary?.url ? (
            <Link to={content.ctaSecondary.url} className="home-btn secondary">
              {content?.ctaSecondary?.label || 'Explore'}
            </Link>
          ) : null}
        </div>
        {stats.length ? (
          <div className="home-stats">
            {stats.map((item) => (
              <div key={`${item.label}-${item.value}`}>
                <strong>{item.value}</strong>
                <span>{item.label}</span>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </section>
  );
}

function TextSection({ section }) {
  const data = section?.data || {};
  const title = data?.title || section?.title;
  const html = data?.body || section?.content || '';
  return (
    <section style={{ padding: '80px 16px', maxWidth: 980, margin: '0 auto' }}>
      {title ? <h2>{title}</h2> : null}
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </section>
  );
}

function GenericSection({ section }) {
  return (
    <section style={{ padding: '70px 16px', maxWidth: 1100, margin: '0 auto' }}>
      {section?.title ? <h2>{section.title}</h2> : null}
      {section?.content ? <p>{section.content}</p> : null}
      <pre style={{ whiteSpace: 'pre-wrap', margin: 0 }}>{JSON.stringify(section?.data || {}, null, 2)}</pre>
    </section>
  );
}

export default function SectionRenderer({ section }) {
  const type = String(section?.component || section?.sectionType || '').trim().toLowerCase();
  const data = section?.data || {};

  if (type === 'hero') {
    return Object.keys(data).length ? <DynamicHero content={data} /> : <HeroSectionComponent />;
  }
  if (type === 'services') return <Services isHomeSection />;
  if (type === 'testimonial' || type === 'testimonials') return <Testimonial />;
  if (type === 'slidingimages' || type === 'slider') return <Slidingimages />;
  if (type === 'about') return <About />;
  if (type === 'contact') return <Contact />;
  if (type === 'career') return <Career />;
  if (type === 'product' || type === 'productpage') return <ProductPage />;
  if (type === 'msme') return <MSMEComponent />;
  if (type === 'ourteam' || type === 'team') return <OurTeam />;
  if (type === 'brochure') return <Brochure />;
  if (type === 'text' || type === 'rich_text' || type === 'html') return <TextSection section={section} />;

  return <GenericSection section={section} />;
}
